<template>
  <div class="pageBody">
    <!-- 带分页表格模板-->
    <div class="ohead">
      <el-input v-model="form.search" placeholder="客户ID" clearable></el-input>
      <el-button
        type="primary"
        @click="
          form.page = 1;
          getData();
        "
        >查 询</el-button
      >

      <div class="buttongroup">
        <el-button type="success" @click="handleExportExcel"
          >导出清单</el-button
        >
        <el-date-picker
          v-model="valuetime"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="datetimerange"
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button type="success" @click="churujindaochu"
          >导出出入金记录</el-button
        >
      </div>
    </div>
    <div class="BodyRow">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="id" label="客户ID" width="180">
        </el-table-column>
        <el-table-column prop="realname" label="客户名称" width="180">
        </el-table-column>
        <el-table-column prop="level" label="客户等级"> </el-table-column>
        <el-table-column prop="y_name" label="对应业务员"> </el-table-column>
        <el-table-column prop="kin" label="预留款金额"> </el-table-column>
        <el-table-column prop="datetime" label="上次交易时间">
        </el-table-column>
      </el-table>
      <div class="allpag">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="50"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      total: 0,
      valuetime: [], //时间选择器
      options: [],
      value: "",
      tableData: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 导出出入金记录
    churujindaochu() {
      if (!this.valuetime[0] || !this.valuetime[1]) {
        return this.$message.warning("请选择日期");
      }
      let params = {
        beginDatetime: this.valuetime[0],
        endDatetime: this.valuetime[1],
      };
      this.$api.financialApi
        .userNyukinList(params)
        .then((res) => {
          require.ensure([], () => {
            const { export_json_to_excel } = require("@/utlis/Export2Excel");

            const tHeader = [
              "日期",
              "客户名",
              "客户ID",
              "收入金额",
              "支出金额",
              "预留款余额",
              "款项说明",
              "订单号或配送单号",
            ];
            const filterVal = [
              "datetime",
              "userName",
              "userid",
              "nyukin",
              "syukin",
              "balance",
              "minyi",
              "ordno",
            ];
            const list = res.data.list; //把data里的tableData存到list
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, "出入金记录");
          });
        })
        .catch((error) => {
          this.$message(error.message);
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.page = val;
      this.getData();
    },
    getData() {
      this.$api.financialApi
        .reservePayment(this.form)
        .then((result) => {
          console.log("reservePayment", result);
          this.tableData = result.data.list;
          this.total = Number(result.data.total);
        })
        .catch((err) => {});
    },
    // excel导出
    handleExportExcel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/utlis/Export2Excel");

        const tHeader = [
          "客户ID",
          "客户名称",
          "会员等级",
          "对应业务员",
          "预留款金额",
          "上次交易时间",
        ];
        const filterVal = [
          "id",
          "realname",
          "level",
          "y_name",
          "kin",
          "datetime",
        ];
        const list = this.tableData; //把data里的tableData存到list
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "预留款列表");
      });
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>
<style scoped lang="scss">
.ohead {
  display: flex;
  margin-bottom: 20px;
  * {
    margin-right: 15px;
  }

  > .el-input {
    width: 220px;
  }
}

.buttongroup {
  margin: 0 0 0 auto;
}

.BodyRow {
  margin-bottom: 20px;
}

.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
</style>
